import {
  AvatarGroup,
  AvatarWithTooltip,
  BetaDataTableCell as Cell,
} from "@zapier/design-system";
import styles from "./AccessCell.module.css";
import { AppMember } from "@zapier/bff";

interface Props {
  members: AppMember[];
  memberCount: number;
}

const AccessCell = ({ members, memberCount }: Props) => {
  return (
    <Cell className={styles.root}>
      {/* display max 3 icons, `app-stats` endpoint will at most return back 4 members. Overflow copy comes from memberCount */}
      <AvatarGroup size="small" max={3} overflowCopy={`${memberCount - 3}`}>
        {members?.map((member, index) => (
          <AvatarWithTooltip
            key={index}
            name={member?.fullName || ""}
            url={member?.photoUrl}
          />
        ))}
      </AvatarGroup>
    </Cell>
  );
};

export default AccessCell;
